import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../../AppActions';

const F = AppActions.F;

function ArticleItem(props) {
  const {item, prebuilt, url, extraStyle} = props;

  if (!item) {
    return <Wrapper extraStyle={extraStyle} />;
  }

  return (
    <Wrapper
      extraStyle={extraStyle}
      href={url}
      onClick={(e) => {
        e.preventDefault();
        AppActions.navigate(url, prebuilt ? {loading: 360} : undefined);
      }}>
      <div className="frame">
        <img
          alt="article-img"
          src={item.cover || '../../images/empty-img.png'}
        />
      </div>
      <div className="info">
        <p>{new Date(item.created).toLocaleDateString().replace(/\//g, '-')}</p>
        <h3>{F(item, 'title')}</h3>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.a`
  display: block;
  margin: 0 auto;

  width: 100%;
  cursor: pointer;

  & > div.frame {
    overflow: hidden;

    & > img {
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      transition: all 400ms;

      &:hover {
        transform: scale(1.05);
        // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.08);
      }
    }
  }

  & > div.info {
    padding: 10px 0;

    & > p {
      color: var(--text-2-color);
      font-size: 0.8rem;
    }

    & > h3 {
      font-size: 1rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: var(--text-4-color);
      font-weight: 300;
    }
  }

  ${(props) => props.extraStyle || ''}
`;

export default ArticleItem;
